function SearchBar (){
  return(
    <input id="SearchBar" type="text" className="col-3" placeholder="Search accounts"></input>
  )
}

export default SearchBar;